// Configuración centralizada para campos condicionales por actividad
// Esta configuración se usa tanto en RegistroForm como en EditDeleteModal

export const ACTIVITY_FIELD_CONFIG = {
  // ID 6: Aplicación de herbicidas
  6: {
    name: "Aplicación de herbicidas",
    showFields: ["cantidad_litros_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },
  
  // ID 2: Fertilización Edáfica (500 - 1000 gr)  
  17: {
    name: "Fertilización Edáfica (500 - 1000 gr)",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

  // ID 5: Plateo Químico
  5: {
    name: "Plateo Químico", 
    showFields: ["cantidad_litros_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

  // ID 7: Fumigación Foliar
  7: {
    name: "Fumigación Foliar",
    showFields: ["cantidad_litros_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

  // ID 16: Fertilización Edáfica (200 - 500 gr)
  16: {
    name: "Fertilización Edáfica (200 - 500 gr)",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

  // ID 19: Fumigación Drench
  19: {
    name: "Fumigación Drench", 
    showFields: ["cantidad_litros_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

   // ID 18: Fertilización Edáfica (1000 - 1500 gr)
   18: {
    name: "Fertilización Edáfica (1000 - 1500 gr)",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

   // ID 15: Aplicaicion Enmienda Mecanica
   15: {
    name: "Aplicaicion Enmienda Mecanica",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

  // ID 14: Aplicaicion Enmienda Manual (5 a 6 Kg)
  14: {
    name: "Aplicaicion Enmienda Manual (5 a 6 Kg",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

   // ID 13: Aplicaicion Enmienda Manual (3 a 4 Kg)
   13: {  
    name: "Aplicaicion Enmienda Manual (3 a 4 Kg)",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },

   // ID 12: Aplicaicion Enmienda Manual (1 a 2 Kg)
   12: {
    name: "Aplicaicion Enmienda Manual (1 a 2 Kg)",
    showFields: ["cantidad_kilos_aplicados"],
    hideFields: ["rendimiento", "unidad_medida"]
  },
};

// Función helper para verificar si un campo debe mostrarse
export const shouldShowField = (actividadId, fieldName) => {
  const config = ACTIVITY_FIELD_CONFIG[actividadId];
  
  // Para campos especiales (litros y kilos), solo mostrar si están explícitamente configurados
  if (fieldName === "cantidad_litros_aplicados" || fieldName === "cantidad_kilos_aplicados") {
    if (!config) return false; // Sin configuración = oculto
    return config.showFields.includes(fieldName);
  }
  
  // Para otros campos, mostrar por defecto excepto si están explícitamente ocultos
  if (!config) return true;
  return config.showFields.includes(fieldName);
};

// Función helper para verificar si un campo debe ocultarse
export const shouldHideField = (actividadId, fieldName) => {
  const config = ACTIVITY_FIELD_CONFIG[actividadId];
  if (!config) return false; // Si no hay configuración, no ocultar
  
  return config.hideFields.includes(fieldName);
};

// Función para obtener todos los campos que deben mostrarse para una actividad
export const getVisibleFields = (actividadId) => {
  const config = ACTIVITY_FIELD_CONFIG[actividadId];
  if (!config) return ["rendimiento", "unidad_medida"]; // Campos por defecto
  
  const allFields = ["cantidad_litros_aplicados", "cantidad_kilos_aplicados", "rendimiento", "unidad_medida"];
  return allFields.filter(field => 
    !config.hideFields.includes(field) && 
    (config.showFields.length === 0 || config.showFields.includes(field))
  );
};

// Función para verificar si debe mostrar rendimiento y unidad de medida
export const shouldShowRendimiento = (actividadId) => {
  return !shouldHideField(actividadId, "rendimiento");
};

// Lista de actividades que tienen campos especiales
export const SPECIAL_ACTIVITIES = Object.keys(ACTIVITY_FIELD_CONFIG).map(id => parseInt(id));

// Funciones específicas para cada tipo de campo
export const showLitrosAplicados = (actividadId) => shouldShowField(actividadId, "cantidad_litros_aplicados");
export const showKilosAplicados = (actividadId) => shouldShowField(actividadId, "cantidad_kilos_aplicados");